module.exports = __webpack_public_path__ + "img/SES_20210222.4b22f133.jpg";